import HttpClient from "../../../core/api/httpClient";
import { UserProfile } from "../model/userProfileDto";

const baseUrl = '/api/user';

export default class ProfileApi {

    static async getUserProfile(): Promise<UserProfile | undefined> {
        try {
            const response = await HttpClient.get(baseUrl);
            return await response.json();
        } catch (error) {
            return undefined
        }
    }
}